import axios from 'axios'
import Cookies from 'js-cookie'

const url = process.env.REACT_APP_SERVER_URL;



export const addProducts = async (data) => {
  const endpoint = `${url}/v1/dashboard-products/add-product`;
  console.log("inputFileData in saga: ", data.data.inputFileData);
  if (data.data.inputFileData) {
    const fileData = new FormData();
    for (const file of data.data.inputFileData) {
      fileData.append('multi-images', file);
    }
    const filesResponse = await axios.post(`${process.env.REACT_APP_SERVER_URL}/v1/upload-multi-photos`, fileData, { headers: { 'Authorization': Cookies.get('token') }, });
    data.data.images = filesResponse.data;
  }
  const response = await axios({
    data,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Cookies.get('token')
    },
    method: 'POST',
    timeout: 1000 * 60 * 10,
    url: endpoint,
  });

  // console.log('--- ', response);

  return response;


}

export const updateProduct = async (data) => {
  const endpoint = `${url}/v1/dashboard-products/edit-product`;
  if (data.inputFileData) {
    const fileData = new FormData();
    // console.log("The files are: ", files);
    for (const file of data.inputFileData) {
      if (typeof (file) === "object")
        fileData.append('multi-images', file);
    }
    const filesResponse = await axios.post(`${process.env.REACT_APP_SERVER_URL}/v1/upload-multi-photos`, fileData, { headers: { 'Authorization': Cookies.get('token') }, });
    data.images = [...data.images, ...filesResponse.data];
  }
  console.log("data.images in update saga backend: ", data.images);
  const removeImagesResponse = await axios.post(`${process.env.REACT_APP_SERVER_URL}/v1/remove-images`, { images: data.images, type: "products", productId: data.id }, { headers: { 'Authorization': Cookies.get('token') }, });
  if (removeImagesResponse.data.success)
    console.log("image files removed that were no longer associated in db! response message: ", removeImagesResponse.data.message);
  const response = await axios({
    data,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Cookies.get('token')
    },
    method: 'PUT',
    timeout: 1000 * 60 * 10,
    url: endpoint,
  });

  // console.log('--- ', response);

  return response;


}
